import APIClient from '@lessonnine/api-client.js';

import {
  APIGATEWAY_BASE_URL,
  AWS_SESSION_ENDPOINT,
  AWS_SESSION_METHOD
} from 'src/dataLayer/env';

let apiClient: APIClient;

export default (): APIClient => {
  if (!apiClient) {
    apiClient = new APIClient({
      baseUrl: APIGATEWAY_BASE_URL,
      awsSessionEndpoint: AWS_SESSION_ENDPOINT,
      awsSessionMethod: AWS_SESSION_METHOD
    });
  }
  return apiClient;
};
